<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">添加关联账号</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :enableSearch="false"
      :requestPromise="loadPromise"
      :queryParams="queryParams"
      :columns="getColumns()"
    >
      <span slot="state" slot-scope="rowItem">
        {{ rowItem.record.state == 1 ? '启用' : '禁用' }}
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.state == 0" @click="enableEvent(rowItem.record.id)">启用</a>
        <a v-else @click="forbiddenEvent(rowItem.record.id)" style="color: red;">禁用</a>
      </span>
    </custom-page-table>
    <a-modal title="添加关联账号" width="600px" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :rules="rules" :model="ruleForm"
                    :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol">
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model.trim="ruleForm.supplierName" :maxLength="6"
                   placeholder="仅用于区分标识数据来源，6个字内"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="企业码" prop="enterpriseCode">
          <a-input v-model.trim="ruleForm.enterpriseCode" placeholder="请输入企业码" :maxLength="120"></a-input>
        </a-form-model-item>
        <a-form-model-item label="用户名" prop="userName">
          <a-input v-model.trim="ruleForm.userName" placeholder="请输入用户名" :maxLength="64"></a-input>
        </a-form-model-item>
        <a-form-model-item label="企业私钥" prop="relatedKey">
          <a-input v-model.trim="ruleForm.relatedKey" placeholder="请输入企业私钥" :maxLength="120"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" :loading="submitLoading" @click="handleSubmit">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'RelationAccount',
  data() {
    return {
      currentFormLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 17 },
        offsetCol: { offset: 5 }
      },
      submitLoading: false,
      visible: false,
      ruleForm: {
        supplierName: '',
        enterpriseCode: '',
        userName: '',
        relatedKey: '',
        merchantId: this.$store.getters.userInfo.merchantId
      },
      rules: {
        supplierName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        enterpriseCode: [
          { required: true, message: '请输入企业码', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        relatedKey: [
          { required: true, message: '请输入企业私钥', trigger: 'blur' }
        ]
      },
      loadPromise: params => this.getListPromise(params),
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        relatedType: 3
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'zhiyoubaoConnection', title: '商品绑定' },
      { name: 'zybOrderConnection', title: '订单直连' },
      { name: 'zybRelationAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getDirectTicketsService().post('directTickets/related/selectAccountList', params)
    },
    //启用事件
    enableEvent(id) {
      this.updateProviderStatus(id, 1)
    },
    //编辑事件
    editEvent(item) {
      this.ruleForm = {
        enterpriseCode: item.enterpriseCode,
        id: item.id,
        merchantId: this.$store.getters.userInfo.merchantId,
        relatedKey: item.relatedKey,
        relatedType: item.relatedType,
        supplierName: item.supplierName,
        userName: item.userName
      }
      this.visible = true
    },
    //禁用事件
    forbiddenEvent(id) {
      this.updateProviderStatus(id, 0)
    },
    //状态更新
    updateProviderStatus(id, status) {
      let params = {
        id: id,
        merchantId: this.$store.getters.userInfo.merchantId,
        relatedType: 3,
        state: status
      }
      this.getHttpServices().getDirectTicketsService().post('directTickets/related/updateAccountState', params)
        .then(res => {
          this.$refs.table.refresh(true)
          this.$message.success('状态更新成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updateProvider() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getHttpServices().getDirectTicketsService().post('directTickets/related/saveAccount', params)
        .then(res => {
          this.$message.success('数据更新成功')
          this.visible = false
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //提交事件
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateProvider()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    openModel() {
      this.visible = true
      this.ruleForm = {
        supplierName: '',
        enterpriseCode: '',
        userName: '',
        relatedKey: '',
        id: 0,
        merchantId: this.$store.getters.userInfo.merchantId,
        relatedType: 3
      }
    },
    handleCancel() {
      this.visible = false
    },
    getColumns() {
      return [
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '企业码',
          dataIndex: 'enterpriseCode'
        },
        {
          title: '用户名',
          dataIndex: 'userName'
        },
        {
          title: '状态',
          dataIndex: 'state',
          scopedSlots: { customRender: 'state' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped></style>
